import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersDrawer } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';

import { useFilters } from '../FiltersState';

import { FiltersPermission } from './FiltersPermission';
import { FiltersScope } from './FiltersScope';

export const MobileFilters = () => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const { search, activeFiltersCount, clearFilters } = useFilters();

  return (
    <Stack row gap="1rem" alignItems="center">
      <InputSearch
        ariaLabel={t({
          id: 'settings.organization.roles.search.label',
          message: 'Search roles',
        })}
        placeholder={t({
          id: 'settings.organization.roles.search.placeholder',
          message: 'Search roles...',
        })}
        value={search.search}
        onChange={search.debouncedSetSearch}
        style={{ flex: 1 }}
      />
      <FiltersDrawer
        button={<FiltersButton count={activeFiltersCount} onClick={() => setIsOpen(true)} />}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onClearFilters={activeFiltersCount ? clearFilters : undefined}
      >
        <FiltersScope />
        <FiltersPermission />
      </FiltersDrawer>
    </Stack>
  );
};
